export default {"src":"/_next/static/media/intr-reversed.7f0fc47b.svg","height":51,"width":64,"blurWidth":0,"blurHeight":0};